import { billingWebConfig } from "../billing/billingConfig";

let generation = 0;
let current = {
  projectId: null,
  uid: null,
  incarnation: null,
  generation: 0,
};

const listeners = new Set();
const controllers = new Set();

function notify() {
  const snapshot = getAuthScope();
  listeners.forEach((listener) => listener(snapshot));
}

export function getAuthScope() {
  return { ...current };
}

export function onAuthScopeChange(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function beginSession({ projectId, uid, incarnation = null } = {}) {
  abortOwnedRequests();
  generation += 1;
  current = {
    projectId: projectId || billingWebConfig.firebase.projectId || null,
    uid: uid || null,
    incarnation: incarnation ?? null,
    generation,
  };
  notify();
  return getAuthScope();
}

export function setIncarnation(incarnation) {
  if (current.incarnation === incarnation) return getAuthScope();
  current = { ...current, incarnation };
  notify();
  return getAuthScope();
}

export function clearSession() {
  abortOwnedRequests();
  generation += 1;
  current = {
    projectId: current.projectId || billingWebConfig.firebase.projectId || null,
    uid: null,
    incarnation: null,
    generation,
  };
  notify();
  return getAuthScope();
}

export function captureScope() {
  return getAuthScope();
}

export function isCurrentScope(scope) {
  if (!scope) return false;
  if (scope.generation !== current.generation) return false;
  if (scope.uid !== current.uid) return false;
  if (scope.projectId !== current.projectId) return false;
  if (
    scope.incarnation != null &&
    current.incarnation != null &&
    scope.incarnation !== current.incarnation
  ) {
    return false;
  }
  return true;
}

export function abortOwnedRequests() {
  controllers.forEach((controller) => {
    try {
      controller.abort();
    } catch {
      /* ignore */
    }
  });
  controllers.clear();
}

export function createScopedAbortController() {
  const controller = new AbortController();
  controllers.add(controller);
  const originalAbort = controller.abort.bind(controller);
  controller.abort = (...args) => {
    controllers.delete(controller);
    return originalAbort(...args);
  };
  return controller;
}

export function publishIfCurrent(scope, value) {
  if (!isCurrentScope(scope)) return false;
  return value;
}
